interface FileReaderEventTarget extends EventTarget {
  result:string
}

export function readAsDataUrl(file: Blob): Promise<string> {
  return new Promise<string> ((res, reject) => {
    let fileReader = new FileReader();

    fileReader.onload = (event: any) => res(event.target.result);

    fileReader.onerror = reject;

    fileReader.readAsDataURL(file);
  });
}

export function createObjectUrl(file: Blob): string {
  return URL.createObjectURL(file);
}




// WEBPACK FOOTER //
// ./src/utilites/helpers/file.ts